export default {
  meta: {
    title: '下载视频',
  },
};
